"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _polished = require("polished");

var _themeGet = require("@styled-system/theme-get");

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _react2 = require("@emotion/react");

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireWildcard(require("../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

var _variants, _templateObject, _templateObject2;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var variants = {
  indeterminate: 'indeterminate',
  determinate: 'determinate'
};
var sizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var propTypes = {
  /**
   * The color of the component. It supports those theme colors and custom colors.
   */
  color: _propTypes.string,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: _propTypes.number,

  /**
   * There are two ways you can increase the height of the progress bar, using
   * this prop or `height` supplied by styled-system.
   */
  size: (0, _propTypes.oneOf)(Object.values(sizes)),

  /**
   * The variant to use.
   */
  variant: (0, _propTypes.oneOf)(Object.values(variants)),

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    bar: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
var defaultProps = {
  value: 0,
  size: sizes.md,
  color: 'primary.main',
  variant: variants.indeterminate,
  classes: {
    root: null,
    bar: null
  }
};
var ProgressBar = (0, _system["default"])('div')({
  label: 'ProgressBar'
}, function (props) {
  var bg = (0, _themeGet.themeGet)("colors.".concat(props.cBg), props.cBg)(props);

  try {
    bg = (0, _polished.rgba)(bg, 0.4);
  } catch (err) {
    bg = 'gray.300';
  }

  return (0, _css["default"])({
    bg: bg,
    width: '100%',
    display: 'block',
    color: props.cBg,
    overflow: 'hidden',
    position: 'relative'
  });
}, (0, _styledSystem.variant)({
  prop: 'cSize',
  scale: 'progressBar',
  variants: (_variants = {}, _defineProperty(_variants, sizes.sm, {
    height: 1
  }), _defineProperty(_variants, sizes.md, {
    height: 2
  }), _defineProperty(_variants, sizes.lg, {
    height: 3
  }), _variants)
}), (0, _system.classesStyles)('root'));
var indeterminate = (0, _react2.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    left: -35%;\n    right: 100%;\n  }\n  60% {\n    left: 100%;\n    right: -90%;\n  }\n  100% {\n    left: 100%;\n    right: -90%;\n  }\n"])));
var indeterminateShort = (0, _react2.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n"])));
var Bar = ( /*#__PURE__*/0, _base["default"])('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0, _isPropValid["default"])(prop) && !['value', 'classes'].includes(prop);
  },
  target: "er76fkm0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0, _isPropValid["default"])(prop) && !['value', 'classes'].includes(prop);
  },
  target: "er76fkm0",
  label: "Bar"
})((0, _css["default"])({
  backgroundColor: 'currentColor'
}), function (_ref) {
  var _variants2;

  var width = _ref.value;
  return (0, _styledSystem.variant)({
    prop: 'variant',
    scale: 'progressBar',
    variants: (_variants2 = {}, _defineProperty(_variants2, variants.determinate, {
      top: 0,
      left: 0,
      bottom: 0,
      width: "".concat(width, "%"),
      position: 'absolute',
      transition: 'width .3s linear'
    }), _defineProperty(_variants2, variants.indeterminate, {
      '&:before, &:after': {
        content: "''",
        position: 'absolute',
        bg: 'inherit',
        top: 0,
        left: 0,
        bottom: 0,
        willChange: 'left, right'
      },
      '&:before': {
        animation: "".concat(indeterminate, " 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite")
      },
      '&:after': {
        animation: "".concat(indeterminateShort, " 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite"),
        animationDelay: '1.15s'
      }
    }), _variants2)
  });
}, (0, _system.classesStyles)('bar'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var value = _ref2.value,
      color = _ref2.color,
      size = _ref2.size,
      props = _objectWithoutProperties(_ref2, ["value", "color", "size"]);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressBar, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    cBg: color,
    cSize: size,
    role: "progressbar",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Bar, {
      classes: props.classes,
      variant: props.variant,
      value: value
    })
  }));
});
Component.displayName = 'ProgressBar';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=ProgressBar.js.map